import { ref, computed } from "vue";
import { useStore } from "vuex";

export default function useEditUserModal(user) {
  const store = useStore();
  const update_fullname = ref(user.name ?? "");
  const update_username = ref(user.email ?? "");

  const loading = computed(() => store.getters["users/isUpdating"]);
  const store_permissions = computed(
    () => store.getters["users/getUserPermissions"] || []
  );
  const user_permissions = ref(
    store_permissions.value.map((permission) => permission.permission)
  );

  const updateUser = async () => {
    const payload = {
      fullnames: update_fullname.value,
      username: update_username.value,
      permissions: user_permissions.value,
    };
    await store.dispatch("users/updateUser", { userId: user.id, payload });
  };

  return {
    loading,
    update_fullname,
    update_username,
    user_permissions,
    updateUser,
  };
}
